import type { Component } from 'vue';
import type { CollectionFieldPath } from '#layers/data-model/public';
import { createContext } from 'reka-ui';

interface ListingContext {
	setDisplayOptionsComponent: (component: Component | null) => void;
	addFieldFilter?: (fieldPath: CollectionFieldPath) => void;
	addFieldFilterWithValue?: (fieldPath: CollectionFieldPath, value: unknown) => void;
}

export const [injectListingContext, provideListingContext] = createContext<ListingContext>('Listing');
